// extracted by mini-css-extract-plugin
export default {"checkbox-list__item":"CheckboxList_checkbox-list__item__Ds9we"};